export default __webpack_public_path__ + "static/media/0.062dc69f.png";